import '@refinitiv-ui/elements/button';
import '../components/heimdall-error.js';
import '../components/heimdall-loader.js';
import '../components/login-frame.js';
import '../theme.js';
import { LitElement, html } from 'lit';
import { startRedirection } from '@lseg-ciam/auth/login';
import {
  defaultAudiencesByClientUid,
  knownLinkOrigins,
} from '../workspace-config.js';
import { appConfig$ } from '../config.js';
import { customElement, state } from 'lit/decorators.js';

@customElement('heimdall-link')
export class HeimdallLink extends LitElement {
  @state()
  _error: unknown = null;

  firstUpdated() {
    const redirectUri =
      location.origin + import.meta.env.BASE_URL + '/redirect/index.html';

    appConfig$.subscribe({
      next: ({ issuerUrl, idpLookupUrl, pnsSub }) => {
        startRedirection({
          issuerUrl,
          redirectUri,
          clientUid: 'workspace',
          idpLookupUrl,
          knownLinkOrigins,
          defaultAudiencesByClientUid,
          pnsSub,
        }).catch((error) => {
          this._error = error;
        });
      },
      error: (error) => {
        this._error = error;
      },
    });
  }

  render() {
    return html`<login-frame> ${this.getFrameContent()} </login-frame>`;
  }

  getFrameContent() {
    if (this._error) {
      return html`<heimdall-error .error=${this._error}></heimdall-error>`;
    }
    return html`<heimdall-loader message=""></heimdall-loader>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'heimdall-link': HeimdallLink;
  }
}
